export const getCodeFromURL = () => {
  const parsed = new URLSearchParams(window.location.search);
  const code = parsed.get("code");
  // window.history.replaceState("", "", document.location.href.split("?")[0]);

  return code || null;
};
